import React, { useState, useEffect } from 'react';
import { PageWrapper, TitleText, BasicText, BasicButton, ShortInput } from '@components';
import logo from '@images/bl-logo.svg';
import styles from './Support.module.css'

const Support = () => {
  return (
    <div className={styles.support_container}>
      <img src={logo} style={{ width: "300px", marginBottom: "60px", cursor: "pointer" }} onClick={() => location.href = "https://www.bookleague.app"}/>

      <div style={{ maxWidth: "320px", marginBottom: "20px" }}>
        <BasicText color="#fff" textAlign="center">
          Thank you for using Book League. We love to get feedback and are always looking to improve the Book League experience.
        </BasicText>
      </div>
      <div style={{ maxWidth: "300px", marginBottom: "20px" }}>
        <BasicText color="#fff" textAlign="center">
          Here's how your can reach us:
        </BasicText>
      </div>

      <div style={{ maxWidth: "300px", marginBottom: "20px", cursor: "pointer" }} onClick={() => window.open("mailto:hello@bookleague.app")}>
        <BasicText color="#67DED0" textAlign="center" fontSize="18px">
          hello@bookleague.app
        </BasicText>
      </div>
    </div>
  );
}

export default Support;
